import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles, Paper, Button } from '@material-ui/core';
import Img from 'gatsby-image';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Link from '../components/link';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    padding: theme.spacing(1),
  },
  image: {
    backgroundColor: theme.palette.primary.main,
    textAlign: 'center',
  },
}));

const showEllipsis = (block) => {
  if (!block.restrictInHeight) return false;

  if (
    block.text.childMarkdownRemark.html ===
    block.text.childMarkdownRemark.excerpt
  )
    return false;

  return true;
};

const renderImages = (images) => {
  return images.length === 1 ? (
    <Img fluid={images[0].fluid} />
  ) : (
    <Carousel showStatus={false} showThumbs={false} interval={150}>
      {images.map((image, i) => (
        <div key={i}>
          <Img fluid={image.fluid} />;
        </div>
      ))}
    </Carousel>
  );
};

const renderText = (text) => {
  return (
    <Typography variant="body2" component="div">
      <span
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      ></span>
    </Typography>
  );
};

const renderEllipsis = (ellipsis, slug) => {
  if (!ellipsis) return null;

  return (
    <Link to={'/' + slug} color="secondary">
      <Button>Read more...</Button>
    </Link>
  );
};

const renderBlock = (block) => {
  const classes = useStyles();
  const ellipsis = showEllipsis(block);

  if (!block.image)
    return (
      <Grid item xs={12}>
        {ellipsis
          ? renderText(block.text.childMarkdownRemark.excerpt)
          : renderText(block.text.childMarkdownRemark.html)}
        {renderEllipsis(ellipsis, block.slug)}
      </Grid>
    );

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        {ellipsis
          ? renderText(block.text.childMarkdownRemark.excerpt)
          : renderText(block.text.childMarkdownRemark.html)}
      </Grid>
      <Grid item md={2}></Grid>
      <Grid item xs={12} md={3} className={classes.image}>
        {renderImages(block.image)}
      </Grid>
      {renderEllipsis(ellipsis, block.slug)}
    </Grid>
  );
};

const Block = ({ block }) => {
  const classes = useStyles();
  return (
    <Paper variant="outlined" className={classes.paper}>
      {renderBlock(block)}
    </Paper>
  );
};

Block.propTypes = {
  block: PropTypes.object.isRequired,
};

export default Block;
